import React from 'react';

import type { Nullable } from '@clearverify/types';

import { useGetEmployeeInfoForVerificationRequestQuery } from 'src/api';

export const useEmployeeInfoForVerificationRequest = (employeeId: Nullable<string>) => {
  const { data, loading } = useGetEmployeeInfoForVerificationRequestQuery({
    variables: { employeeId: employeeId || '' },
    skip: !employeeId,
  });

  const employeeInfoForVerificationRequest = React.useMemo(
    () => data?.getEmployeeInfoForVerificationRequest,
    [data?.getEmployeeInfoForVerificationRequest],
  );

  return {
    employeeInfoForVerificationRequest,
    loading,
  };
};
